module.exports = __webpack_public_path__ + "img/accessory_item_03.63cce885.svg";